import MagicRetailerSignupPage from "@faire/prototype-playground/workspace/ja/magic-retailer-signup";
import MobileWebNavTapTargetsPage from "@faire/prototype-playground/workspace/ja/mobile-web-nav-targets";
import PostHogCostCalculatorPage from "@faire/prototype-playground/workspace/ja/posthog-cost-calculator";
import SccNonBmMockupPage from "@faire/prototype-playground/workspace/ja/scc-non-bm-mockup";
import SignupInlineFieldHelpPage from "@faire/prototype-playground/workspace/ja/signup-inline-field-help";
import SignupHelperIdeasPage from "@faire/prototype-playground/workspace/ja/signup-helper-ideas";
import SignupHelperLearningsPage from "@faire/prototype-playground/workspace/ja/signup-helper-learnings";
import SignupAsAPlatformM2Page from "@faire/prototype-playground/workspace/ja/signup-platform-m-2";
import SocialProfileSignupPage from "@faire/prototype-playground/workspace/ja/social-profile-signup";
import TestMyFeaturePage from "@faire/prototype-playground/workspace/ja/test-my-feature";
import { Route, Switch } from "react-router-dom";

export function JohnAdesidaRoutes() {
  return (
    <Switch>
      <Route path="/ja/scc-non-bm-mockup" component={SccNonBmMockupPage} />
      <Route
        path="/ja/signup-helper-learnings"
        component={SignupHelperLearningsPage}
      />
      <Route
        path="/ja/signup-platform-m-2"
        component={SignupAsAPlatformM2Page}
      />
      <Route
        path="/ja/posthog-cost-calculator"
        component={PostHogCostCalculatorPage}
      />
      <Route
        path="/ja/social-profile-signup"
        component={SocialProfileSignupPage}
      />
      <Route
        path="/ja/magic-retailer-signup"
        component={MagicRetailerSignupPage}
      />
      <Route path="/ja/mobile-web-nav-targets" component={MobileWebNavTapTargetsPage} />
      <Route
        path="/ja/signup-helper-ideas"
        component={SignupHelperIdeasPage}
      />
      <Route
        path="/ja/signup-inline-field-help"
        component={SignupInlineFieldHelpPage}
      />
      <Route path="/ja/test-my-feature" component={TestMyFeaturePage} />
    </Switch>
  );
}

export const slug = "ja";
